import PropTypes from 'prop-types';
import React from 'react';
import Button from '../Button';
import css from './ResultsListEmpty.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ResultsListEmpty = function ResultsListEmpty(_ref) {
  var copy = _ref.copy,
      onClear = _ref.onClear;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h3", {
      className: css.title,
      children: "No Results Found"
    }), /*#__PURE__*/_jsx("p", {
      className: css.copy,
      children: copy
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onClear,
      children: "Clear Filters"
    })]
  });
};

ResultsListEmpty.defaultProps = {
  copy: 'Looks like there aren’t any products in stock with the filters you’ve selected.'
};
ResultsListEmpty.propTypes = {
  copy: PropTypes.string,
  onClear: PropTypes.func.isRequired
};
export default ResultsListEmpty;